import React from 'react';
import Cards from 'components/Core/Cards';
import EventCard from 'components/Core/Cards/EventCard';

const ContentfulColumnCardWrapper = (item) => {
  if (item?.templateName === 'EventCard') {
    return <EventCard {...item} />;
  }
  return <Cards {...item} />;
};

export default ContentfulColumnCardWrapper;
